"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getVariantSummary = void 0;
const __1 = require("..");
const getVariantRegions_1 = require("./getVariantRegions");
const getVariantSummary = (variant) => {
    if (!variant || !variant.order_lines)
        return {
            regions: "",
            estimated: false,
            description: "",
            total: "",
            margin: "",
        };
    const number_of_rounds = (0, __1.getVariantNumberOfRounds)(variant);
    const number_of_nights = (0, __1.getVariantNumberOfNights)(variant);
    const estimated = (0, __1.variantHasEstimatedPrices)(variant);
    const total = (0, __1.getVariantTotal)(variant);
    const currency = (0, __1.getVariantCurrency)(variant) || "";
    const margin = (0, __1.getTotalVariantMargin)(variant);
    const regions = (0, getVariantRegions_1.getVariantRegions)(variant);
    const description = (number_of_nights > 0 ? `${number_of_nights}N` : "") +
        (number_of_nights > 0 && number_of_rounds > 0 ? "/" : "") +
        (number_of_rounds > 0 ? `${number_of_rounds}R` : "");
    // ✅ Calculate percentage margin (only if total > 0)
    const marginPercent = total > 0 ? ((margin / total) * 100).toFixed(1) + "%" : "";
    return {
        regions: regions.join(", "),
        estimated,
        description,
        total: (0, __1.currencyFormatter)(currency, total, false),
        // ✅ Show margin as currency + percentage
        margin: `${(0, __1.currencyFormatter)(currency, margin, false)}${marginPercent ? ` (${marginPercent})` : ""}`,
    };
};
exports.getVariantSummary = getVariantSummary;
